import React from 'react';
import ToolTip from '../ToolTip';
import styles from './AboutTab.css';

const AboutTab = ({ text, isActive, onClick, isDisabled, cursor="pointer", ...props }) => (
  <a
    {...props}
    onClick={onClick}
    className={`${styles.aboutTab} ${isActive ? styles.isActive : ''} ${isDisabled ? styles.isDisabled : ''}`}
    data-ga-on="click"
    data-ga-event-category="Video"
    data-ga-event-action={text}
    style={{cursor}}
  >
    {text}
    {isDisabled ? (
      <ToolTip className={styles.tooltip} text="5/27 一起來看" />
    ) : null}
  </a>
);

export default AboutTab;



// WEBPACK FOOTER //
// ./src/components/AboutTab/index.js